// Mirror of the backend note_text bounds
// (cloud: app/controllers/v1/machine_notes/schemas.py). Keep in sync.
export const NOTE_TEXT_MAX_LENGTH = 5000;
export const NOTE_TEXT_MIN_LENGTH = 2;
